registerComponent("sections/seja-cliente", function (component) {
/**
 * A entrada na rolagem (ADR 0051): as peças marcadas `.entrada` no HTML entram
 * quando a seção chega na tela — numa linha escalonada no desktop, uma a uma
 * abaixo do degrau. Ver `Asa.armarEntrada` em assets/.scripts/asa.js e
 * assets/.styles/_entrada.less.
 *
 * O campo de SMS (ADR 0087): máscara, validação, botão de envio e o toast —
 * tudo em `Asa.formularioSms`, compartilhado com o modal "Abrir conta".
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

Asa.armarEntrada([component], '.entrada');
Asa.formularioSms(component.querySelector('.baixe-app__sms'));

});
